// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2B9C9","productName":"Table_productName__zS402"};